import Box from "@mui/material/Box";
import FormSection from "components/forms/FormSection";
import EmployeeCollectionTable from "pages/EmployeeWorkspace/components/EmployeeCollectionTable";
import resource from "pages/EmployeeWorkspace/Resources/specialSkillResource";
import { useState } from "react";
import DeleteConfirmationDialog from "features/maintenance/components/DeleteConfirmationDialog";
import EmptyPlaceHolder from "pages/EmployeeWorkspace/components/EmptyPlaceHolder";
import FormDialog from "pages/EmployeeWorkspace/components/Tabs/components/SpecialSkillsTab/components/FormDialog";

export default function SpecialSkillsTab({ form, updateField }) {
    const [dialogOpen, setDialogOpen] = useState(false);
    const [editingIndex, setEditingIndex] = useState(null);
    const [dataToDelete, setDataToDelete] = useState(null);

    const editingData =
        editingIndex !== null
            ? form[resource.collectionField]?.[editingIndex]
            : null;

    const handleSave = (newData) => {
        const data = { ...newData, rowId: newData?.id || crypto.randomUUID() };
        const currentData = form[resource.collectionField] ?? [];
        if (editingIndex !== null) {
            const updatedData = [...currentData];

            updatedData[editingIndex] = data;

            updateField(resource.collectionField, updatedData);
        } else {
            updateField(resource.collectionField, [...currentData, data]);
        }

        setEditingIndex(null);
        setDialogOpen(false);
    };

    const handleEdit = (data, index) => {
        setEditingIndex(index);
        setDialogOpen(true);
    };

    const handleAdd = () => {
        setEditingIndex(null);
        setDialogOpen(true);
    };

    const handleDelete = () => {
        const currentData = form[resource.collectionField] ?? [];

        if (!dataToDelete) {
            return;
        }

        let updatedData;

        if (dataToDelete.id > 0) {
            updatedData = currentData.map((values) =>
                values === dataToDelete
                    ? {
                          ...values,
                          isDeleted: true
                      }
                    : values
            );
        } else {
            updatedData = currentData.filter(
                (values) => values !== dataToDelete
            );
        }

        updateField(resource.collectionField, updatedData);

        setDataToDelete(null);
    };

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1.5
            }}
        >
            <FormSection title={resource.title} icon={resource.icon}>
                {/* {!!form[resource.collectionField]?.length && (
                    <Button
                        variant="contained"
                        onClick={() => {
                            setEditingIndex(null);
                            setDialogOpen(true);
                        }}
                        sx={{ mb: 2 }}
                    >
                        Add {resource.singular}
                    </Button>
                )}*/}

                {!form[resource.collectionField]?.length ? (
                    <EmptyPlaceHolder
                        title={resource.title}
                        onAdd={handleAdd}
                        icon={resource.icon}
                    />
                ) : (
                    <EmployeeCollectionTable
                        resource={resource}
                        rows={(form[resource.collectionField] ?? []).filter(
                            (values) => !values.isDeleted
                        )}
                        onEdit={handleEdit}
                        onDelete={(values) => {
                            setDataToDelete(values);
                        }}
                        onAdd={handleAdd}
                    />
                )}
                <FormDialog
                    open={dialogOpen}
                    item={editingData}
                    onCancel={() => {
                        setDialogOpen(false);
                        setEditingIndex(null);
                    }}
                    onSave={handleSave}
                />
                <DeleteConfirmationDialog
                    open={dataToDelete !== null}
                    title={`Delete ${resource.title}`}
                    message={`Are you sure you want to remove this ${resource.title}?`}
                    onCancel={() => setDataToDelete(null)}
                    onConfirm={handleDelete}
                />
            </FormSection>
        </Box>
    );
}
